import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from "@angular/router";
import { AuthenticationService } from '../../../services/security';
import { AppConsts } from '../../../shared/app-consts';
import { BehaviorSubject, Observable } from "rxjs";
import { ConfirmationService } from 'primeng/primeng';
@Component({
  selector: 'app-account-menu',
  templateUrl: './account-menu-v2.component.html',
  styleUrls: ['./account-menu.component.css']
})
export class AccountMenuComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter();
  currentEmail: string = '';
  userName: any;
  constructor(private authService: AuthenticationService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.authService.authenticationState.subscribe(() => {
      var jwtToken = JSON.parse(sessionStorage.getItem(AppConsts.TOKEN_KEY));
      this.userName = jwtToken == null ? '' : jwtToken.FullName;
      this.currentEmail = jwtToken == null ? '' : jwtToken.UserEMail;
    });
  }

  closeMenu(){
    this.close.emit();
  }

  logout() {
    this.confirmationService.confirm({
      message: `Êtes-vous sûr de vouloir vous déconnecter ?`,
      key : 'logoutConfirm',
      accept: () => { 
        this.authService.logout();
      }
    });
  }
}
